function cache(img)
{
	let i = document.createElement("img");
	i.src = img;
	// i.onload =() => {i.parentNode.removeChild(i)};
	// i.onerror = () => {i.parentNode.removeChild(i)};
}

function cacheAfter(to, img)
{
	let c = ((img) => {
		return () => {cache(img);}
	})(img);
	setTimeout(c, to)
}

export function cacheImages(images : string[], minWait, spread)
{
	for (let img of images) {
		let rand = minWait + spread * Math.random();
		cacheAfter(rand, img)
	}
}
